"use strict";

function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
window.addEventListener('load', () => {});
customElements.define('ec-cpm-lightbox', class extends HTMLElement {
  constructor() {
    super();
    this._wasActive = false;
    this.flkty = null;
    this.classObserver = null;
    this.removedSlideCache = [];
    this.originalSlideCache = [];
    this.variant = null;
    this.lightboxEl = null;
    this.flickityEl = null;
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleLightboxOpened = this.handleLightboxOpened.bind(this);
    this.handleLightboxClosed = this.handleLightboxClosed.bind(this);
  }
  connectedCallback() {
    this.lightboxEl = this.querySelector('.lightbox[data-lightbox]');
    if (!this.lightboxEl) return;
    this.classObserver = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isActive = this.lightboxEl.classList.contains('active');
          if (isActive && !this._wasActive) {
            this._wasActive = true;
            this.handleLightboxOpened();
          } else if (!isActive && this._wasActive) {
            this._wasActive = false;
            this.handleLightboxClosed();
          }
        }
      }
    });
    this.classObserver.observe(this.lightboxEl, {
      attributes: true,
      attributeFilter: ['class']
    });
    this.flickityEl = this.querySelector('.lightbox__images');
    if (!this.flickityEl || !window.flu) return;
    if (this.hasAttribute('data-section-id') && this.getAttribute('data-section-id').trim() !== '') {
      const regex = /.+/;
      if (regex.test(this.getAttribute('data-section-id'))) {
        document.addEventListener(`${this.getAttribute('data-section-id')}-completed`, e => {
          if (e?.detail) this.handleUpdate(e.detail);
        });
        document.addEventListener(`${this.getAttribute('data-section-id')}-update`, e => {
          if (e?.detail) this.handleUpdate(e.detail);
        });
      }
    }
  }
  disconnectedCallback() {
    if (this.classObserver) {
      this.classObserver.disconnect();
      this.classObserver = null;
      this.removedSlideCache.clear();
    }
  }
  async handleLightboxOpened() {
    const result = await (specifier => new Promise(r => r(`${specifier}`)).then(s => _interopRequireWildcard(require(s))))(window.flu?.chunks?.flickity);
    if (!result?.Flickity) return;
    this.flkty = result.Flickity.data(this.flickityEl);
    if (!this.flkty) return;
    this.originalSlideCache = this.flkty.slides.map((slide, index) => ({
      element: slide.cells[0].element,
      originalIndex: index
    }));
    this.flkty.slides.forEach((slide, index) => {
      const el = slide.cells[0].element;
      if (el?.hasAttribute('data-variant-image') && Number(el.getAttribute('data-id')) !== this.variant?.default?.featured_media?.id) {
        this.removedSlideCache.push({
          element: el,
          originalIndex: index
        });
        this.flkty.remove(el);
      }
      if (Number(el.getAttribute('data-id')) === this.variant?.default?.featured_media?.id) {
        this.flkty.remove(el);
        this.flkty.prepend(el);
      }
    });
    this.flkty.slides.forEach((slide, index) => {
      slide.cells[0].element.setAttribute('data-slide-index', index);
    });
    this.flkty.reloadCells();
  }
  handleLightboxClosed() {
    if (!this.flkty) return;
    while (this.flkty.slides.length > 0) {
      this.flkty.remove(this.flkty.slides[0].cells[0].element);
    }
    this.originalSlideCache.forEach(({
      element,
      originalIndex
    }) => {
      this.flkty.insert(element, originalIndex);
    });
    this.flkty.reloadCells();
    this.flkty.select(0);
  }
  handleUpdate(detail) {
    if (!detail?.state?.variant) return;
    this.variant = detail?.state?.variant;
  }
});